<script>
  import auth from '../api/auth.js';

  import { onMount } from 'svelte';

  onMount(async () => {
    auth.logout();
    close();
  });
</script>

<div>
  <small>Logged Out</small>
</div>

